export const USER_STATE = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const USER_STATE_DICTIONARY = {
    [USER_STATE.ACTIVE]: "Active",
    [USER_STATE.INACTIVE]: "Inactive",
};
